import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading, isAdminOrStaff, rolesLoaded } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Aspetta che i ruoli siano caricati prima di decidere il redirect admin,
  // altrimenti un admin che ricarica /admin verrebbe sbattuto su / perché
  // isAdminOrStaff è ancora false nella finestra in cui i ruoli arrivano.
  if (requireAdmin && !rolesLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (requireAdmin && !isAdminOrStaff) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
